// export default {
// install: function (Vue, options) {
// 1. 添加全局方法或属性
// 略
import Vue from 'vue'
// 2. 添加全局资源
// 时间格式化过滤器，输入内容是number或者Date对象，输出是YYYY-MM-DD HH-MM-SS
Vue.filter('formatTime', function (value) {
    //13位时间戳
    Date.prototype.Format = function (fmt) { //author: meizz
        var o = {
            "M+": this.getMonth() + 1, //月份
            "d+": this.getDate(), //日
            "h+": this.getHours(), //小时
            "m+": this.getMinutes(), //分
            "s+": this.getSeconds(), //秒
            "q+": Math.floor((this.getMonth() + 3) / 3), //季度
            "S": this.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt))
            fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt))
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    }
    return new Date(value).Format("yyyy-MM-dd hh:mm:ss");
})


Vue.filter('filterTime', function (value) {
    //11位时间戳
    Date.prototype.Format = function (fmt) { //author: meizz
        var o = {
            "M+": this.getMonth() + 1, //月份
            "d+": this.getDate(), //日
            "h+": this.getHours(), //小时
            "m+": this.getMinutes(), //分
            "s+": this.getSeconds(), //秒
            "q+": Math.floor((this.getMonth() + 3) / 3), //季度
            "S": this.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt))
            fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt))
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    }
    return new Date(value * 1000).Format("yyyy-MM-dd hh:mm:ss");
})

// 3. 注入组件
// 注入组件，所有组件都会执行这里边的方法，所以把返回方法定义到这里，其他vue页面可以直接调用
Vue.mixin({
    data () {
        return {
            firstLoad: false,
            hasContent: false,
            firstplay: true,
            is_active: 0, //期末活动
            is_summer: 0, //暑假活动
            is_winter: 0,//寒假活动
            urlList: [
                '/new/open/task/sx/type6', //数学错题本视频
                '/new/open/task/sx/type2', //数学作业-订正错题
                '/new/open/task/sx/type1', //数学作业-试题解析
                '/new/open/task/sx/type3', //数学作业-底部开通
                '/new/open/task/sx/type5', //数学作业-知识点解析
                '/new/open/task/yw/type3', //语文错题本视频
            ], //埋点数据
            smsContent: '',
            smsParams: {},
            smsId: null,
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            playFlag: false,
            videoUrl: '',
        }
    },
    created: function () {
        //原生回调方法不能放到公共里面，并且在组件销毁时设为null
        // window.playfinished = function () {
        //   this.play_boon = true
        //   this.firstplay = true
        // }
    },
    methods: {
        
        /**退出视频 */
        closePlayer () {
            this.playFlag = false;
        },
        getSmsdate (_time) {
            let _t = new Date(_time * 1000);
            let _m = (_t.getMonth() + 1) >= 10 ? (_t.getMonth() + 1) : '0' + (_t.getMonth() + 1);
            let _d = _t.getDate() >= 10 ? _t.getDate() : '0' + _t.getDate();
            let _i = `${_t.getFullYear()}-${_m}-${_d}`;
            return _i;
        },
        getSms (sms_id = 3) {
            return new Promise((resolve, reject) => {
                this.$http.post(API_URL_BASE_API + '/sms/get_sms/', {
                    "sms_id": sms_id
                }).then(res => {
                    this.smsContent = res.data.data.content;
                    this.smsId = res.data.data.id;
                    resolve(res);
                })
            })
        },
        replaceSms (sms) {
            if (!this.smsContent.length) {
                return false;
            }
            let content = this.smsContent.replace('{now_time}', this.smsParams.now_time).replace('{end_time}', this.smsParams.end_time).replace('{subject}', this.smsParams.subject).replace('{task_type}', this.smsParams.task_type).replace('{user_name}', this.smsParams.user_name).trim(); //不可以用全部空格
            return content;
        },
        VuePostUserInfo (url) { //埋点数据
            if (url.length && url.length > 6) {
                let urlOrigin = this.$store.state.urlOrigin || '0';
                this.VuePostUserInfoObj.VuePostUserInfo(0, 0, urlOrigin, url);
            }
        },
        ysRefresh () {
            // try { appobject.Interactive("ys_refresh_task") } catch (e) { console.log(e); }
            this.appFunction("ys_refresh_task", "");
        },
        test: function () {
            console.log("mixin test");
        },
        Unicdoe (str) {
            if (!str) { return; }
            var unicode = '';
            str = str.replace(/\s+/g, ' ').replace(/^\s/, '').replace(/\s$/, '').toUpperCase();
            for (var i = 0; i < str.length; i++) {
                var temp = str.charAt(i);
                if (this.isChinese(temp)) {
                    unicode += '\\u' + temp.charCodeAt(0).toString(16);
                } else {
                    unicode += temp;
                }
            }
            return unicode;
        },
        isChinese (s) { //判断字符是否为汉字，
            return /[\u4e00-\u9fa5]/.test(s);
        },
        stopScroll () { /***禁止出现弹框页面滑动限制***/
            document.documentElement.style.position = 'fixed';
            document.body.style.overflow = 'hidden'; //隐藏滚动条
        },

        moveScroll () { /***取消滑动限制***/
            document.documentElement.style.position = 'static';
            document.body.style.overflow = ''; //出现滚动条
        },
        back () {
            if (window.location.href.indexOf('/subjectChoose') > -1 ||
                window.location.href.indexOf('/star') > -1 && !this.is_active && !this.is_summer && !this.is_winter ||
                window.location.href.indexOf('/sx/knowledge/watchVideo') > -1 && !this.is_summer && !this.is_winter ||
                window.location.href.indexOf('/chinese/dotask/donatural') > -1) {
                this.appFunction("ys_finish", "");
            } else {
                this.$router.go(-1);
            }
        },
        play (url) {//视频播放方法
            if(this.inApp){
                this.appFunction("ys_video", url);
            }else{
                layer.tips('请前往APP观看')
            }
            
        },
        playaudio (url) {//音频播放方法
            this.stopaudio();
            try {
                this.appFunction("ys_start_audio", url);
                this.play_boon = !this.play_boon
                this.firstplay = false
            } catch (e) {
                this.play_boon = !this.play_boon
                this.firstplay = false
                console.log(e)
            }
        },
        pauseaudio () {//音频暂停播放方法
            try {
                // appobject.Interactive('ys_pause_audio');
                this.appFunction("ys_pause_audio", "");
                this.play_boon = !this.play_boon
            } catch (e) {
                this.play_boon = !this.play_boon;
                console.log(e)
            }
        },
        goonaudio () {//音频继续播放方法
            try {
                // appobject.Interactive('ys_goon_audio');
                this.appFunction("ys_goon_audio", "");
                this.play_boon = !this.play_boon
            } catch (e) {
                this.play_boon = !this.play_boon;
                console.log(e)
            }
        },
        stopaudio () {//音频停止播放方法
            this.appFunction('ys_stop_audio', "")
        },
        select_card (question, type) { //学生做题滚动
            clearTimeout(window.footTime);
            var isDOM = (typeof HTMLElement === 'object') ? function (obj) {
                return obj instanceof HTMLElement;
            } :
                function (obj) {
                    return obj && typeof obj === 'object' && obj.nodeType === 1 && typeof obj.nodeName === 'string';
                }
            var obj = document.getElementById('q' + question.id);
            let pEl = document.getElementById('con');
            // 学生端语文 选择 start
            if (`${obj.getAttribute('class')}` != 'null' && obj.getAttribute('class').indexOf('border_choose') > -1) { // 存在class属性且含有border_choose属性
                obj = obj.previousElementSibling;
            }
            // 学生端语文 选择&填空 end
            let topEl = pEl.querySelector('.title');
            let _offsetTop = obj.offsetTop - pEl.offsetTop - 40;
            let winoffsetTop = document.body.scrollTop || document.documentElement.scrollTop;
            if (isDOM(type) && _offsetTop < 0) {
                _offsetTop = pEl.scrollTop + type.offsetTop - 64;
            } else if (type) {
                let title = type.parentNode
                // let btn = document.querySelector('#footer').clientHeight;
                // let keyBoard = document.querySelector('.key-board').clientHeight;
                _offsetTop = _offsetTop + type.offsetTop - 100;
                // window.scrollTo(0, obj.offsetTop - 100);

                // return false
            }

            let speed = 2;
            scrollT();
            function scrollT () {
                clearTimeout(window.anind);
                window.anind = null;
                window.anind = setTimeout(function () {
                    if (winoffsetTop < _offsetTop) {
                        window.scrollTo(0, winoffsetTop += speed);
                        if (winoffsetTop < _offsetTop) {
                            speed += 1;
                            scrollT();
                        }
                    } else {
                        window.scrollTo(0, winoffsetTop -= speed);
                        if (winoffsetTop > _offsetTop) {
                            speed += 1;
                            scrollT();
                        }
                    }
                }, 16);
            }

            // window.anind = setInterval(function () {
            //   window.scrollTo(0, winoffsetTop += 2);
            //   if (winoffsetTop >= _offsetTop) {
            //     clearInterval(window.anind);
            //   }
            // }, 1);
        },
        openPop (type, index, newWebview) {
            let _this = this;
            type = type ? type : 2;
            let title = type === 5 ? '语文' : type === 9 ? '英语' : type == 11 ? '书法课程' : type == 12 ? '编程课程' : type == 13 ? '模型课程' : '数学';
            // let sxCon = '开通后可观看精品名师视频，薄弱知识举一反三，更有奥数课程，首次开通赠送30天哦！';
            // let ywCon = '开通后享受名师定制预习方案，全面透彻学习课本知识，首次开通赠送30天哦！';
            // let yyCon = '开通后享受英语课外拓展全部模块，智能英语发音系统，锻炼地道口语，首次开通赠送30天哦！';
            // let content = type === 5 ? ywCon : type === 9 ? yyCon : sxCon;
            let content = '您需开通学科后才可享受后续服务';
            let tbkt_token = localStorage.getItem('Tbkt-Token');
            let modelname = index ? '&modelname=' + index : '';
            layer.open({
                title: '开通' + title,
                content: content,
                btn: ['现在开通', '以后再说'],
                yes: function (index) {
                    let platform = JSON.parse(localStorage.getItem('userInfo.city_id'));
                    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
                    if (platform === '130000') {
                        _this.$http.post(API_URL_BANK_API + '/hb/cmcc_open/', { phone: userInfo.phone }).then((res) => {
                            if (res.body.response == 'ok') {
                                layer.alert('您好，稍后您将收到短信，请按照短信提示操作开通即可！', 'stu', function (index) {
                                    layer.closeAll();
                                })
                            } else {
                                layer.alert(res.body.message, 'stu', function (index) {
                                    layer.closeAll();
                                })
                            }
                        })
                    } else {
                        _this.appFunction("ys_return_key", "key_app")
                        let { platform, app_version } = JSON.parse(localStorage.getItem('search'));
                        let fullPath = `${VUE_URL_EXPAND}/new/open/${type}?add_type=5&tbkt_token=${tbkt_token}${modelname}&platform=${platform}&app_version=${app_version}&v=${(+new Date())}`;
                        if (newWebview) {
                            _this.appFunction("ys_task_detail", `${fullPath}`);
                            console.log(fullPath);
                        } else {
                            location.href = fullPath + "&from=1";
                        }
                    }
                    layer.close(index);
                }
            })
        },

        appFunction (name, obj, url) {
            let { platform } = JSON.parse(localStorage.getItem('search'));
            let array = [];
            obj = obj ? obj : "";
            if (obj.indexOf(',') > -1) {
                array = obj.split(',')
            } else {
                array.push(obj)
            }
            if (name == "ys_task_list_eng") {//特殊方法，传递参数不同
                let _o = {
                    id: array[0],
                    key1: array[1],
                    key2: array[2]
                }
                array = _o;
            }
            if (platform == '3') {
                try {
                    window.webkit.messageHandlers[`${name}`].postMessage(array);
                } catch (e) {
                    if (url == '1') {
                        this.$router.go(-1)
                    } else if (url && url.length > 0) {
                        this.$router.push(url)
                    }
                    console.log(e)
                }
            } else {
                let appObg = obj ? `${name},${obj}` : `${name}`;
                try {
                    appobject.Interactive(appObg)
                } catch (e) {
                    if (url == '1') {
                        this.$router.go(-1)
                    } else if (url && url.length > 0) {
                        this.$router.push(url)
                    }
                    console.log(e)
                }
            }
        },
    },
    beforeRouteEnter (to, from, next) { //埋点
        next(vm => {
            vm.$store.state.urlOrigin = from.path;
        })
    },
});


// 4. 添加实例方法
// 服务组，将实例方法整合到$service中，避免命名冲突
Vue.prototype.$service = {
    //电话号码合法性检查
    telNumberCheck: function (tel) {
        var pattern = /(^(([0\+]\d{2,3}-)?(0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$)|(^0{0,1}1[3|4|5|6|7|8|9][0-9]{9}$)/;
        return pattern.test(tel)
    }
}
// }
// };
// 4. 输出不同时间格式/*lijianqiang*/
/*用法：
    {{dateTime | dateFormat}} //
    {{dateTime | dateFormat('MM月DD号 hh点mm分') }}*/
Vue.filter("dateFormat", function (date, format = 'MM月DD hh:mm') {
    if (!!date) {
        date = date.split('-').join('/');
        let _date = new Date(date);
        let o = {
            "M+": _date.getMonth() + 1, //month
            "D+": _date.getDate(), //day
            "h+": _date.getHours(), //hour
            "m+": _date.getMinutes(), //minute
            "s+": _date.getSeconds(), //second
            "q+": Math.floor((_date.getMonth() + 3) / 3), //quarter
            "S": _date.getMilliseconds() //millisecond
        }

        // 只输出星期几;
        if (/W/.test(format)) {
            format = format.replace(/W/, '星期' + "日一二三四五六".charAt(_date.getDay()));
        }

        if (/(Y+)/.test(format)) {
            format = format.replace(RegExp.$1, (_date.getFullYear() + "").substr(4 - RegExp.$1.length));
        }

        for (var k in o) {
            if (new RegExp("(" + k + ")").test(format)) {
                format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
            }
        }
    } else {
        return date
    }
    return format;
}),
    /*字符串替换字符*/
    Vue.filter("strReplace", function (str, strOld, strNew) {
        if (str && str.indexOf(strOld) > -1) {
            return str.replace(new RegExp(strOld, 'g'), strNew)
        } else {
            return str
        }
    })
